/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type ChatType = typeof ChatType[keyof typeof ChatType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatType = {
  Direct: 'Direct',
  PrivateGroup: 'PrivateGroup',
  Broadcast: 'Broadcast',
  PublicGroup: 'PublicGroup',
  Feed: 'Feed',
  BroadcastFeed: 'BroadcastFeed',
} as const;
